const LIVE_CONNECTION_VALIDATION_WAIT_MS = 65_000;
const MOCK_CONNECTION_VALIDATION_WAIT_MS = 10_000;

export const CONNECTION_VALIDATION_WAIT_MS =
  import.meta.env.VITE_USE_MOCKS === "true"
    ? MOCK_CONNECTION_VALIDATION_WAIT_MS
    : LIVE_CONNECTION_VALIDATION_WAIT_MS;
